import { Observable, of } from 'rxjs';
import { map, tap, switchMap, take } from 'rxjs/operators';

import { IConfigSetting } from '../interfaces/models';
import {
  PAGES,
  PageConfig,
  Endpoint,
  CentralApis,
} from '../interfaces/internal';
import { Page } from './page';
import { ConfigSetting } from '../models/configSetting';
import { Result } from '../interfaces/helpers';

export class ConfigSettingPage extends Page<ConfigSetting> {
  constructor({ endpoint }: Endpoint, config: PageConfig) {
    const url = (endpoint as CentralApis).appConfig + 'config';

    super(url, PAGES.CONFIG_SETTING, config);

    this.initializeColumns({ keys: new ConfigSetting() });
  }

  fetch(queryString?): Observable<Result<ConfigSetting>> {
    return this.getItems(queryString).pipe(
      tap(({ items }) => {
        this.pageItems.next(items);
      })
    );
  }

  fetchById(id: string): Observable<ConfigSetting> {
    return this.getItem(id).pipe(
      map((data: IConfigSetting) => this.createFromDTO(data))
    );
  }

  update(item: IConfigSetting): Observable<ConfigSetting> {
    let updatedPicklist: IConfigSetting[];

    return this.items.pipe(
      take(1),
      switchMap((picks) => {
        if (!picks || picks.length <= 0) {
          return this.fetch().pipe(map(({ items }) => items));
        } else {
          return of(picks);
        }
      }),
      switchMap((picks) => {
        const picklistIndex = picks.findIndex((i) => i.id === item.id);
        updatedPicklist = [...picks];

        return this.updateItems(updatedPicklist[picklistIndex]);
      }),
      tap(() => {
        this.pageItems.next(updatedPicklist);
      })
    );
  }

  createFromDTO(item): ConfigSetting {
    return new ConfigSetting({
      id: 0,
      name: item.name,
      value: item.value,
      type: item.type,
      createdAt: item.createdAt,
      createdBy: item.createdBy,
      modifiedBy: item.modifiedBy,
      modifiedAt: item.modifiedAt,
    });
  }
}
